import { render } from "./BuyForm.vue?vue&type=template&id=71bd9e14&scoped=true&ts=true"
import script from "./BuyForm.vue?vue&type=script&lang=ts"
export * from "./BuyForm.vue?vue&type=script&lang=ts"

import "./BuyForm.vue?vue&type=style&index=0&id=71bd9e14&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bd9e14"]])

export default __exports__